import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPartNumberStoreStyles {
    productPartNumbersStyles?: ProductPartNumbersStyles;
}

const textStyles = {
    css: css`
        color: ${COLORS.text.base};
        font-weight: ${TYPOGRAPHY.weight.bold};

        ${({ theme }) => {
            return breakpointValuesMediaQueries(
                theme,
                [{ values: ["18px", null, "22px", null, null], properties: ["font-size"] }],
                mediaOptions.min,
            );
        }}
    `,
};

export const productDetailsPartNumberStoreStyles: ProductDetailsPartNumberStoreStyles = {
    productPartNumbersStyles: {
        partNumberValueText: {
            css: css`
                ${textStyles?.css}
            `,
        },
        labelTextStyle: {
            css: css`
                ${textStyles?.css}
                font-weight: ${TYPOGRAPHY.weight.medium};
                font-size: ${TYPOGRAPHY.size.large};
                margin-right: 5px;
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [
                            {
                                values: [`${TYPOGRAPHY.size.base}`, null, `${TYPOGRAPHY.size.large}`, null, null],
                                properties: ["font-size"],
                            },
                        ],
                        mediaOptions.min,
                    )}
            `,
        },
        valueTextStyle: {
            css: css`
                ${textStyles?.css}
            `,
        },
    },
};

const styles = productDetailsPartNumberStoreStyles;

const ProductDetailsPartNumberStore: React.FC<Props> = ({ product }) => {
    if (!product.productNumber) {
        return null;
    }

    const canadianTireNumber = product?.properties?.canadianTireInfo
        ? JSON.parse(product.properties.canadianTireInfo).canadianTireNumber
        : null;

    return (
        <>
            <ProductPartNumbers
                productNumber={product.productNumber}
                canadianTireNumber={canadianTireNumber}
                extendedStyles={styles.productPartNumbersStyles}
            />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsPartNumberStore),
    definition: {
        displayName: "Part Number Store",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
